var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movimentacoes-table" },
    [
      _c(
        "BaseTable",
        _vm._b(
          {
            attrs: {
              title: _vm.title,
              "custom-sort": _vm.customSort,
              headers: _vm.headers,
              items: _vm.tableItems,
              loading: _vm.loading,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "search-value": _vm.search,
              "disable-margin-top": ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "no-data",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "full-center my-10" },
                        [
                          _vm.showAssetNameColumn
                            ? _c("p", { staticClass: "text-bold" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.emptyStateAssetLabel) + " "
                                )
                              ])
                            : _vm._e(),
                          _vm.hasAssetSelected
                            ? [
                                _c("p", { staticClass: "text-bold" }, [
                                  _vm._v(
                                    " Este ativo não possui nenhuma movimentação cadastrada. "
                                  )
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " Para conseguir calcular a rentabilidade dele, é necessário ter ao menos uma movimentação cadastrada. "
                                  )
                                ]),
                                _c(
                                  "BaseButton",
                                  {
                                    attrs: { primary: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openMovimentacoes(_vm.asset)
                                      }
                                    }
                                  },
                                  [_vm._v(" Adicionar movimentação ")]
                                )
                              ]
                            : [
                                _c("p", { staticClass: "text-bold" }, [
                                  _vm._v(
                                    " Nenhuma movimentação encontrada para os filtros selecionados. "
                                  )
                                ]),
                                _c("p", [
                                  _vm._v(
                                    "Selecione apenas um ativo para adicionar uma movimentação."
                                  )
                                ])
                              ]
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "item.icon",
                  fn: function(ref) {
                    var item = ref.item
                    return [_c("EventIcon", { attrs: { event: item } })]
                  }
                },
                !_vm.asset || !_vm.asset.id || _vm.showAssetNameColumn
                  ? {
                      key: "item.nome_ativo",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getAssetNameText({ item: item })) +
                                " "
                            )
                          ])
                        ]
                      }
                    }
                  : null,
                {
                  key: "item.operacao",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-items-center az-gap-small"
                        },
                        [
                          _vm._v(" " + _vm._s(item.operacao) + " "),
                          _vm.sugestoesPorLinha[item.id_aplicacao]
                            ? _c("IaSuggestionsPendingBadge", {
                                attrs: {
                                  pendentes:
                                    _vm.sugestoesPorLinha[item.id_aplicacao],
                                  "data-test": "mov-sugestoes-ia"
                                },
                                on: {
                                  revisar: function($event) {
                                    return _vm.$emit("revisar-sugestoes", item)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                },
                {
                  key: "item.origem",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.FORMAT_ORIGEM[item.origem] || item.origem
                          ) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "item.quantidade",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.quantityText({ item: item })) + " "
                      )
                    ]
                  }
                },
                {
                  key: "item.valor_unitario",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.unitPriceText({ item: item })) + " "
                      )
                    ]
                  }
                },
                {
                  key: "item.action",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _vm.shouldShowUnitPriceAlert(item)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { "max-width": "300", left: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      {},
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("icon-svg", {
                                                      attrs: {
                                                        name: "warning",
                                                        color: _vm.warningColor
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " Para calcular a rentabilidade, é necessário preencher o preço unitário e quantidade desta movimentação. "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("TableRowActions", {
                            attrs: {
                              actions: _vm.getMovementActions({ item: item })
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          },
          "BaseTable",
          _vm.atributosSemPaginacao,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }